import NestedAttributesTable from './NestedAttributesTable';

export default NestedAttributesTable;
